/**
 * Chemins relatifs de l'API EasyLoc (préfixe {@code environment.apiUrl}).
 */
export const API_PATHS = {
  biens: '/biens',
  bien: (id: string) => `/biens/${id}`,
  bienLogements: (idBien: string) => `/biens/${idBien}/logements`,
  logements: '/logements',
  logement: (id: string) => `/logements/${id}`,
  logementDocumentsTechniques: (logementId: string) =>
    `/logements/${logementId}/documents-techniques`,
  logementDocumentTechnique: (logementId: string, documentId: string) =>
    `/logements/${logementId}/documents-techniques/${documentId}`,
  logementDocumentTechniqueFichier: (logementId: string, documentId: string) =>
    `/logements/${logementId}/documents-techniques/${documentId}/fichier`,
  logementDocumentTechniqueExpiration: (
    logementId: string,
    documentId: string
  ) =>
    `/logements/${logementId}/documents-techniques/${documentId}/expiration`,
  bienDocumentsAchat: (bienId: string) => `/biens/${bienId}/documents-achat`,
  bienDocumentAchat: (bienId: string, documentId: string) =>
    `/biens/${bienId}/documents-achat/${documentId}`,
  bienDocumentAchatFichier: (bienId: string, documentId: string) =>
    `/biens/${bienId}/documents-achat/${documentId}/fichier`,
  contacts: '/contacts',
  contact: (id: string) => `/contacts/${id}`,
  contactRefuser: (id: string) => `/contacts/${id}/refuser`,
  contactReouvrir: (id: string) => `/contacts/${id}/reouvrir`,
  locataires: '/locataires',
  locataire: (id: string) => `/locataires/${id}`,
  locataireReactiver: (id: string) => `/locataires/${id}/reactiver`,
  authLogin: '/auth/login',
  authRefresh: '/auth/refresh',
  authLogout: '/auth/logout',
} as const;

/** Noms de query params partagés (filtres listes documents, etc.). */
export const API_QUERY_PARAMS = {
  logementId: 'logementId',
  type: 'type',
  q: 'q',
  definitive: 'definitive',
} as const;
